export default __webpack_public_path__ + "static/media/Uploadinmedia.ae450778.svg";